import * as React from 'react'
import MUICheckbox from '@mui/material/Checkbox'

const Checkbox = (props) => <MUICheckbox {...props} />

export default Checkbox
